import prod from "./prod";
import preprod from "./preprod";
import dev from "./development";

let environment;
if (process.env.REACT_APP_NODE_ENV === "production") {
  environment = prod;
} else if (process.env.REACT_APP_NODE_ENV === "preprod") {
  environment = preprod;
} else {
  environment = dev;
}

export default environment;
